// extracted by mini-css-extract-plugin
export default {"wrapper":"wS-z","availablePromoMessagesLabel":"xS-z","promoMessageList":"yS-z","promoMessage":"zS-z","appliedPromoMessage":"AS-z","promoMessageAmount":"BS-z"};